module.exports = __webpack_public_path__ + "img/Carousel-funcionalidades-icono-03.f987e9e4.svg";